export const SET_WORKSTATION_LIST = 'SET_WORKSTATION_LIST'
export const TOGGLE_WORKSTATION = 'TOGGLE_WORKSTATION'
export const SET_WORKSTATION_ITEMLIST = 'SET_WORKSTATION_ITEMLIST'
export const TOGGLE_IS_MAIN_CHANNEL = 'TOGGLE_IS_MAIN_CHANNEL'
